<template>
  <div class="zzzd_ADContainer">
    <div class="zzzd_ADWrapper">
      <div class="zzzd_header">
        <i class="el-icon-back zzzd_icon" @click="goBack"></i><span>诊断结果</span>
      </div>
      <div class="zzzd_loading">
        <img src="@/assets/imgs/zzzd/undraw_authentication_fsn5.png" alt="">
      </div>
      <div class="zzzd_desc">
        <span>人工审核中，请稍候...</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      timer:null
    };
  },
  methods: {
    goBack(){
      this.$router.push('/diagnose/personal/myDiagnosis')
    }
  },
  mounted(){
  
  },
  destroyed(){
  }
};
</script>

<style lang="scss" scoped>
.zzzd_ADContainer {
  background: #F3F3F3;
  width: 100%;
  min-height: 100%;
  padding-bottom: 29px;
  .zzzd_ADWrapper {
    // width: 1190px;
    background: #F3F3F3;
    height: 100%;
    // margin:29px auto 0;
    // padding: 40px 27px;
    .zzzd_loading{
      img{
        margin: auto;
        margin-top: 50px;
        margin-bottom: 20px;
      }
    }
    .zzzd_desc{
        margin-top: 47px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:22px;
        text-align: center;
    }
    .zzzd_header {
      width: 100%;
      height: 50px;
      background: #fff;
      font-size: 18px;
      padding-left: 20px;
      line-height: 50px;
      font-weight: 600;
      .zzzd_icon{
        color:#409EFF;
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>